import { usingGet } from '@ocean/api'

export const getRapidElearning = () =>
  usingGet('Search/Library/RapidElearnings', { useProxy: true })
